<template>
  <sparkline
    v-if="options"
    :id="id"
    :options="options"
    :value="`${value}`"
    :year="`${year} 1Ls`"
    :url="url"
    :color="colors.indigo[600]"
    :max="600"
    title="1L enrollment"
    :help="terms.firstYearEnrollment"
  />
</template>

<script setup>
import Sparkline from "@/components/sparklines/Sparkline.vue"
import colors from "@/colors"
import route from "ziggy-js"
import terms from "@/terms"
import { computed, onMounted, ref } from "vue"

const props = defineProps({
  school: { type: Object, required: true },
  field: { type: String, default: "enrollees_All" },
})

const firstYear = computed(() => props.school.admissions[0].admission_year)
const id = computed(() => `${props.school.slug}-enrollment`)
const url = computed(() => route("schools.admissions", props.school.slug))
const value = ref()
const year = ref()
const options = ref()

onMounted(() => {
  const admissions = props.school.admissions.filter((admission) => admission.admission_year >= firstYear.value)
  const defaultValue = admissions[admissions.length - 1][props.field]
  const defaultYear = admissions[admissions.length - 1].admission_year
  value.value = defaultValue
  year.value = defaultYear

  const series = [{
    type: "areaspline",
    data: admissions.map((item) => item[props.field]),
    point: {
      events: {
        mouseOver() {
          value.value = this.y
          year.value = this.x + firstYear.value
        },
        mouseOut() {
          value.value = defaultValue
          year.value = defaultYear
        },
      },
    },
  }]

  options.value = {
    series,
  }
})
</script>
